export default __webpack_public_path__ + "static/media/wavy-check.aaa31552.svg";